import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../components/LoadingSpinner';
import { FaMasksTheater, FaPeopleRoof, FaGraduationCap, FaTrophy, FaBuildingUser, FaBus } from "react-icons/fa6";
import { FaHeartbeat } from "react-icons/fa";
import { BiCategoryAlt } from "react-icons/bi";
import useTitle from '../../hooks/useTitle';

// Маппинг иконок для секторов
const sectorIcons = {
    'culture': <FaMasksTheater className="icon" />,
    'social': <FaPeopleRoof className="icon" />,
    'education': <FaGraduationCap className="icon" />,
    'healthcare': <FaHeartbeat className="icon" />,
    'sport': <FaTrophy className="icon" />,
    'transport': <FaBus className="icon" />,
    'private': <FaBuildingUser className="icon" />,
    'other': <BiCategoryAlt className="icon" />
};

const AdminProjectCategories = () => {
    const { data: sectorsWithProjects, loading, error } = useSelector(state => state.sectorsWithProjects);
    const navigate = useNavigate();

    // Задаем название сайта
    useTitle('Категории проектов | Админ-панель');

    // Преобразуем данные с API в формат, подходящий для компонента
    const formatSectorData = () => {
        if (!sectorsWithProjects || sectorsWithProjects.length === 0) return [];

        return sectorsWithProjects.map(sector => ({
            id: sector.id.toString(),
            name: sector.name,
            title: sector.title,
            icon: sectorIcons[sector.name] || <BiCategoryAlt className="icon" />,
            projects: sector.projects.map(p => p.projectName)
        }));
    };

    const projectsData = formatSectorData();

    const handleProjectCategoryClick = (projectCategory) => {
        navigate(`/performance-admin-panel/project-categories/${projectCategory.name}`);
    };

    return (
        <Container className="py-4">
            <h2 className="mb-4">Категории проектов</h2>
             {loading ? 
                    <div className="spinner-container">
                        <LoadingSpinner message="Загрузка информации о проектах..."/>
                    </div> :
                error ? 
                    <div className="alert alert-danger">
                        {error}
                    </div> 
                :
                <div className="projects-content mb-5">
                    <Row className="categories-grid">
                        {projectsData.map((category) => (
                            <Col lg={6} className="mb-4" key={category.id}>
                                <div className="category-card">
                                    <div className="category-header" onClick={() => handleProjectCategoryClick(category)}>
                                        <div className="category-icon">
                                            {category.icon}
                                        </div>
                                        <div className="category-info">
                                            <div className="category-name">{category.title}</div>
                                            <div className="category-count">Количество проектов <span className="count-badge">{category.projects.length}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            }
        </Container>
    );
};

export default AdminProjectCategories;